import React, { useState } from "react";

import { MODE_CLOSED, MODE_OPEN, MODE_DONE } from "./constants";
import AddProductPriceView from "./AddProductPriceView";

const AddProductPrice = ({ productId, product }) => {
  const [mode, setMode] = useState(MODE_CLOSED);

  return (
    <AddProductPriceView
      {...{
        productId,
        mode,
        product,
        onAddPrice: () => setMode(MODE_OPEN),
        onCancel: () => setMode(MODE_CLOSED),
        onDone: () => setMode(MODE_DONE),
      }}
    />
  );
};

export default AddProductPrice;
